import React, { useEffect, useState, useRef } from "react";
import { createFarmacia, resetFarmaciasFlag } from "../../../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Col, Row, Input, Label, Form, Alert, Spinner, Button } from "reactstrap";
import { Navigate } from "react-router-dom";
import { uploadLogoFarmacia } from "../../../helpers/backend_helper";
import logoDefault from "../../../assets/images/companies/img-1.png";

const CrearFarmacia = (props) => {
  const dispatch = useDispatch();

  const selectLayoutState = (state) => state;

  const pageData = createSelector(selectLayoutState, (state) => ({
    farmacia: state.Farmacias.farmacia,
    error: state.Farmacias.error,
    loading: state.Farmacias.loading,
    errorMsg: state.Farmacias.errorMsg,
    colorMsg: state.Farmacias.colorMsg,
    exito: state.Farmacias.exito,
  }));

  // Inside your component
  const { farmacia, error, loading, errorMsg, colorMsg, exito } =
    useSelector(pageData);

  const [nombre, setNombre] = useState("");
  const [codigo_farmabien, setCodigoFarmabien] = useState("");
  const [codigo_myh, setCodigoMyh] = useState("");
  const [direccion, setDireccion] = useState("");
  const [coordenadas, setCoordenadas] = useState("");

  const [redireccionar, setRedireccionar] = useState(false);
  const [loadingx, setLoadingx] = useState(false);

  // Estados para logo
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoBase64, setLogoBase64] = useState(null);
  const [logoError, setLogoError] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetFarmaciasFlag());
        setLoadingx(false);
      }, 2000);
    }
  }, [dispatch, errorMsg]);

  useEffect(() => {
    const subirLogoYRedirigir = async () => {
      if (exito && farmacia?.id && logoBase64) {
        try {
          await uploadLogoFarmacia(farmacia.id, logoBase64);
        } catch (err) {
          console.error('Error al subir logo:', err);
        }
      }
      if (exito) {
        setTimeout(() => {
          setRedireccionar(true);
        }, 2000);
      }
    };
    subirLogoYRedirigir();
  }, [exito, farmacia, logoBase64]);

  // Función para manejar la selección de logo
  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      setLogoError('Por favor selecciona una imagen válida');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setLogoError('La imagen no debe superar los 5MB');
      return;
    }

    setLogoError(null);
    const reader = new FileReader();
    reader.onloadend = () => {
      setLogoPreview(reader.result);
      setLogoBase64(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveLogo = () => {
    setLogoPreview(null);
    setLogoBase64(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const obj = {
      nombre: nombre.trim(),
      codigo_farmabien: codigo_farmabien.trim(),
      codigo_myh: codigo_myh.trim(),
      direccion: direccion.trim(),
      coordenadas: coordenadas.trim(),
    };

    try {
      const response = await dispatch(createFarmacia(obj));
      if (response.error) {
        throw new Error(response.error.message);
      }
      setLoadingx(true);
    } catch (error) {
      console.error("Error al crear una Farmacia:", error);
      // Aquí puedes manejar el error, por ejemplo, mostrando un mensaje al usuario
    }
  };

  return (
    <>
      {redireccionar && <Navigate to="/farmacias" replace />}

      <React.Fragment>
        {errorMsg && errorMsg ? (
          <Alert color={colorMsg}> {error} </Alert>
        ) : null}

        <Form onSubmit={handleSubmit}>
          {/* Sección de Logo */}
          <Row className="mb-4 p-3">
            <Col lg={12}>
              <div className="d-flex align-items-center gap-4">
                <div className="position-relative">
                  <img
                    src={logoPreview || logoDefault}
                    alt="Logo de farmacia"
                    className="rounded"
                    style={{ width: '100px', height: '100px', objectFit: 'contain', border: '1px solid #e9ebec' }}
                  />
                </div>
                <div>
                  <h6 className="mb-2">Logo de la Farmacia</h6>
                  <p className="text-muted mb-2 small">JPG, PNG o GIF. Máximo 5MB. (Opcional)</p>
                  <div className="d-flex gap-2">
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleLogoChange}
                      accept="image/*"
                      style={{ display: 'none' }}
                    />
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => fileInputRef.current?.click()}
                    >
                      <i className="ri-upload-2-line me-1"></i>
                      Seleccionar
                    </Button>
                    {logoPreview && (
                      <Button
                        color="danger"
                        size="sm"
                        outline
                        onClick={handleRemoveLogo}
                      >
                        <i className="ri-delete-bin-line me-1"></i>
                        Quitar
                      </Button>
                    )}
                  </div>
                  {logoError && (
                    <Alert color="danger" className="mt-2 mb-0 py-1 px-2">
                      {logoError}
                    </Alert>
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <hr className="mb-3" />
          <Row lg={12} className="p-3">
            <Col xxl={6} md={6}>
              <div className="mb-3">
                <Label className="form-label" htmlFor="nombre">
                  Nombre <span className="text-danger">*</span>
                </Label>

                <Input
                  required
                  minLength={3}
                  maxLength={50}
                  type="text"
                  className="form-control"
                  id="nombre"
                  name="nombre"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                />
              </div>
            </Col>
            <Col xxl={6} md={6}>
              <div className="mb-3">
                <Label className="form-label" htmlFor="codigo_farmabien">
                  Codigo Farmacia <span className="text-danger">*</span>
                </Label>

                <Input
                  required
                  minLength={3}
                  maxLength={50}
                  type="text"
                  className="form-control"
                  id="codigo_farmabien"
                  name="codigo_farmabien"
                  value={codigo_farmabien}
                  onChange={(e) => setCodigoFarmabien(e.target.value)}
                />
              </div>
            </Col>
            <Col xxl={6} md={6}>
              <div>
                <Label className="form-label" htmlFor="codigo_myh">
                  Codigo MyH+ <span className="text-danger">*</span>
                </Label>

                <Input
                  required
                  minLength={3}
                  maxLength={50}
                  type="text"
                  className="form-control"
                  id="codigo_myh"
                  name="codigo_myh"
                  value={codigo_myh}
                  onChange={(e) => setCodigoMyh(e.target.value)}
                />
              </div>
            </Col>

            <Col xxl={6} md={6}>
              <div className="mb-3">
                <Label className="form-label" htmlFor="coordenadas">
                  Coordenadas <span className="text-danger">*</span>
                </Label>

                <Input
                  required
                  minLength={3}
                  maxLength={50}
                  type="text"
                  className="form-control"
                  id="coordenadas"
                  name="coordenadas"
                  value={coordenadas}
                  onChange={(e) => setCoordenadas(e.target.value)}
                />
              </div>
            </Col>
            <Col xxl={12} md={12}>
              <div className="mb-3">
                <Label className="form-label" htmlFor="direccion">
                  Direccion <span className="text-danger">*</span>
                </Label>
                <Input
                  type="textarea"
                  required
                  className="form-control"
                  id="direccion"
                  name="direccion"
                  value={direccion}
                  onChange={(e) => setDireccion(e.target.value)}
                />
              </div>
            </Col>
          </Row>
          <Row className="align-items-end">
            <Col lg={12}>
              <div className="mt-4 mb-3 text-end">
                <button
                  type="submit"
                  className="btn btn-success btn-label right ms-auto nexttab nexttab"
                >
                  {loadingx ? (
                    <Spinner size="sm" className="me-2">
                      {" "}
                      Loading...{" "}
                    </Spinner>
                  ) : null}
                  <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                  Crear Farmacia
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </React.Fragment>
    </>
  );
};

export default CrearFarmacia;
